import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const LocationModal = ({ show, onHide, onSubmit, withoutLocation }) => {
    const [title, setTitle] = useState("");
    const [address, setAddress] = useState("");
    const [phone, setPhone] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ title, address, phone });
    };

    return (
        <Modal show={show} onHide={onHide} centered dir="rtl">
            <Modal.Header closeButton>
                <Modal.Title>ثبت آدرس جدید</Modal.Title>
            </Modal.Header>
            {
                withoutLocation &&
                <div className='alert my-3 alert-warning text-justify p-2 mx-2 text-small-1'>
                    شما در حال ثبت یک آدرس به صورت دستی (بدون موقعیت هستید). برای خدمات دهی با کیفیت تر، بهتر است موقعیت خود را روی نقشه مشخص کنید
                </div>
            }
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3" controlId="addressTitle">
                        <Form.Label>عنوان آدرس</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                            placeholder="عنوانی برای آدرس"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="exactAddress">
                        <Form.Label>آدرس دقیق</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            required
                            placeholder="آدرس کامل"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="phoneNumber">
                        <Form.Label>شماره تماس</Form.Label>
                        <Form.Control
                            type="text"
                            value={phone}
                            maxLength={15}
                            onChange={(e) => setPhone(e.target.value)}
                            placeholder="مثال: 0912xxxxxxx"
                            required
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" type="submit">
                        ثبت آدرس
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default LocationModal;
